<div class="especialidade-medica-container">
    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        <div class="secoes">
            @for (secao of secoes; track secao.titulo) {
                <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        @for (campo of secao.campos; track campo.label) {
                            <ng-container [ngTemplateOutlet]="campoDaSecao" [ngTemplateOutletContext]="{ secao: secao, campo: campo }" />
                        }
                    </div>
                </app-card-content>
            }

            <app-card-content [headerColor]="false" [title]="'Especialidades Solicitadas'" [icon]="iconeDaSecao('Especialidades Solicitadas')" [subtitle]="subtituloDaSecao('Especialidades Solicitadas')">
                @if (!especialidades.length) {
                    <div class="feedback">Nenhuma especialidade informada.</div>
                } @else {
                    <div class="especialidades-lista">
                        @for (item of especialidades; track $index) {
                            <article class="especialidade-item">
                                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                                    <div class="field">
                                        <label class="font-semibold block mb-2" [for]="idDoCampoDaEspecialidade($index, 'Especialidade')">Especialidade</label>
                                        <input pInputText [id]="idDoCampoDaEspecialidade($index, 'Especialidade')" class="w-full" [value]="valorCampoEspecialidade(item, 'especialidade')" disabled />
                                    </div>
                                    <div class="field">
                                        <label class="font-semibold block mb-2" [for]="idDoCampoDaEspecialidade($index, 'Tipo Documento')">Tipo Documento</label>
                                        <input pInputText [id]="idDoCampoDaEspecialidade($index, 'Tipo Documento')" class="w-full" [value]="valorCampoEspecialidade(item, 'tipoDocumentoEspecialidadeArea')" disabled />
                                    </div>
                                    <div class="field">
                                        <label class="font-semibold block mb-2" [for]="idDoCampoDaEspecialidade($index, 'Data Expedicao Diploma')">Data Expedição Diploma</label>
                                        <input pInputText [id]="idDoCampoDaEspecialidade($index, 'Data Expedicao Diploma')" class="w-full" [value]="valorCampoEspecialidade(item, 'dataExpedicaoDiploma')" disabled />
                                    </div>
                                    <div class="campo">
                                        <span class="campo-label">Anexo</span>
                                        @if (possuiAnexo(item)) {
                                            <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event, item)" aria-label="Visualizar anexo" title="Visualizar anexo">
                                                <i class="pi pi-paperclip"></i>
                                                <span>Visualizar anexo</span>
                                            </button>
                                        } @else {
                                            <strong class="campo-valor">-</strong>
                                        }
                                    </div>
                                </div>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        </div>
    }
</div>

<!--
    Um campo, nas duas formas - o mesmo desenho dos detalhamentos de consultorio privado e PCMSO.

    `secaoEhDeDados` (vocabulário compartilhado) decide a forma. Nas secoes de dados o campo sai como controle DESABILITADO:
    e a aparencia do detalhamento de pre-prestador, e desabilitado porque esta tela e de leitura.
    Em "Protocolo", que segue como texto, a situacao mantem o badge que a colore.
-->
<ng-template #campoDaSecao let-secao="secao" let-campo="campo">
    @if (secaoEhDeDados(secao.titulo)) {
        <div class="field">
            <label class="font-semibold block mb-2" [for]="idDoCampo(secao, campo)">{{ campo.label }}</label>
            <input pInputText [id]="idDoCampo(secao, campo)" class="w-full" [value]="valorCampo(campo)" disabled />
        </div>
    } @else {
        <article
            class="campo"
            [class.campo--destaque-identificacao]="campo.label.toLowerCase().trim().startsWith('cpf') || campo.label.toLowerCase().trim().startsWith('crm') || campo.label.toLowerCase().includes('cnpj')"
            [class.campo--situacao]="ehCampoBadge(campo)"
        >
            <span class="campo-label">{{ campo.label }}</span>
            @if (ehCampoBadge(campo)) {
                <span [class]="'campo-badge situacao-' + situacaoClassePorTexto(valorCampo(campo))">
                    {{ rotuloBadgeSituacao(campo.label, valorCampo(campo)) }}
                </span>
                @if (protocoloSelecionado()?.inPago === false) {
                    <span class="campo-badge campo-badge-pagamento nao-pago">Não pago</span>
                }
            } @else {
                <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
            }
        </article>
    }
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
